import api from "../../../config/api/index.js";
import type { LoginCredentials, ApiResponse, LoginResponse } from "./types.js";

// ============== POST - ورود ادمین ==============
/**
 * Login
 * @param data - (LoginCredentials)
 * @returns پاسخ سرور
 */
export const LoginApi = async (data: LoginCredentials): Promise<{ data: ApiResponse<LoginResponse>; headers: any }> => {
    try {
        const response = await api.post<ApiResponse<LoginResponse>>(
            `managerPanel/login/super_admin`,
            data
        );
        return {
            data: response.data,
            headers: response.headers,
        };
    } catch (error) {
        console.error("Failed to login:", error);
        throw error;
    }
};
export interface ChangeAdminPasswordPayload {
    oldPassword: string;
    newPassword: string;
    repeatPass: string;
}

export const ChangeAdminPasswordApi = async (
    payload: ChangeAdminPasswordPayload
): Promise<ApiResponse<any>> => {
    const res = await api.post<ApiResponse<any>>(
        "/managerPanel/login/changePassword",
        payload
    );
    return res.data;
};